import { SET_CANCEL } from 'store/constants/action-types';

export const setCancelAction = (payload) => {
  return { type: SET_CANCEL, payload: payload };
};
